
scittle.asami.init();